import React, { useEffect, useRef, useState } from 'react';

import { Container, Button, Dropdown, DropdownButton, Alert, Col, Row, Spinner, Modal, Tooltip, InputGroup, Form } from 'react-bootstrap';
import { EditionService } from '../../../services/EditionService';
import { UserService } from '../../../services/UserService';
import ErrorManager from "../../../components/error-manager/ErrorManager";

//import './SendMailDialog.scss';

const ChangePasswordDialog = ({ show, setCloseModal }) => {

    const [showModal, setShowModal] = useState(false);
    const [globalError, setGlobalError] = useState();
    const [isSendLoading, setIsSendLoading] = useState(false);
    const [isSaved, setIsSaved] = useState(false);

    useEffect(() => {
        setShowModal(show)
        if (show) {
            resetValues()
        }
    }, [show]);

    function resetValues() {
        setGlobalError()
        setIsSendLoading(false)
        setIsSaved(false)
    }

    function handleClose(e) {
        setCloseModal()
    }

    function saveResetPassword() {
        setIsSendLoading(true)
        UserService.postResetPassword().then(res => {
            setIsSendLoading(false)
            setIsSaved(true)
        }).catch(error => {
            setGlobalError(error)
            setIsSendLoading(false)
        });
    }

    return (
        <div id="ChangePasswordDialog">
            <Modal show={showModal} onHide={() => handleClose()} centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Réinitialiser le mot de passe</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <ErrorManager error={globalError} />

                    {isSaved &&
                        <Alert variant="success">Un email de réinitialisation vous a été envoyé.</Alert>
                    }

                    {!isSaved &&
                        <p>Un email vous sera envoyé pour réinitialiser votre mot de passe.</p>
                    }


                </Modal.Body>
                <Modal.Footer>

                    <Button disabled={isSendLoading} variant="secondary" onClick={handleClose}>
                        Fermer
                    </Button>

                    {!isSaved &&
                        <Button disabled={isSendLoading} className="ms-1" onClick={() => saveResetPassword()}>
                            Envoyer l'email
                        </Button>
                    }

                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ChangePasswordDialog;
